import React from 'react';
import compraClickLogo from '../assets/compraclick-brand.png';
import brandLogoWhite from '../assets/brand-logo-white.svg';
import { i18n } from '../utils';

i18n.initialize();

const CheckoutHeader = ({merchantName, subsidiaryImageFilename, isButton = true}) => {
  i18n.changeLanguage(localStorage.getItem('productLanguage'));

  return (
    <header className={`main-header main-header--${isButton ? 'button' : 'order' }`}>
      <div className="main-header__container container">
        <div className="main-header__logo">
          <img
            src={isButton ? compraClickLogo : brandLogoWhite}
            alt={`${isButton ? 'CompraClick | ' : ''}Credomatic`}
            height="42"
          />
        </div>
        <div className="main-header__data data">
          { isButton
            ? (
              <React.Fragment>
                {merchantName && <div className="data__merchant">{merchantName}</div>}
                { subsidiaryImageFilename
                    && <div className="data__subsidiary-logo"><img src={subsidiaryImageFilename}/></div> }
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="data__my-checkout">{ i18n.t('my_checkout') }</div>
                { merchantName
                    && <div className="data__pay-to">{ i18n.t('pay_to_merchant') } {merchantName}</div> }
              </React.Fragment>
            )
          }
        </div>
      </div>
    </header>
  )
}

export default CheckoutHeader;


// WEBPACK FOOTER //
// ./client/components/CheckoutHeader.js